export const AWS_ACCOUNT_ID_LENGTH = 12;

export const AWS_STS_EXTERNAL_ID_MIN_LENGTH = 2;

export const AWS_STS_EXTERNAL_ID_MAX_LENGTH = 1224;
